import { render, staticRenderFns } from "./TopCatch.vue?vue&type=template&id=70ad3674"
import script from "./TopCatch.vue?vue&type=script&lang=js"
export * from "./TopCatch.vue?vue&type=script&lang=js"
import style0 from "./TopCatch.vue?vue&type=style&index=0&id=70ad3674&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports